"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWidgetStore = exports.getWidgetStore = exports.rootReducers = exports.setErrorCodeAction = void 0;
const constant_1 = require("../constant");
const reducer_1 = require("./datasheetMap/reducer");
const core_1 = require("@apitable/core");
const reducer_2 = require("./permission/reducer");
const reducer_3 = require("./widget/reducer");
const redux_1 = require("redux");
const { unitInfo, pageParams, mirrorMap, collaborators } = core_1.Reducers;
const setErrorCodeAction = (payload) => ({ type: constant_1.SET_ERROR_CODE, payload });
exports.setErrorCodeAction = setErrorCodeAction;
exports.rootReducers = (0, redux_1.combineReducers)({
    widget: reducer_3.widgetReducer,
    datasheetMap: reducer_1.datasheetMapReducer,
    unitInfo: unitInfo,
    pageParams: pageParams,
    mirrorMap: mirrorMap,
    collaborators: collaborators,
    permission: reducer_2.permissionReducer,
    errorCode: (state = null, action) => {
        switch (action.type) {
            case constant_1.SET_ERROR_CODE:
                return action.payload;
            default:
                return state;
        }
    },
    user: (state = null, action) => {
        switch (action.type) {
            case constant_1.SET_USER_INFO: {
                state = action.payload;
                return state;
            }
            default:
                return state;
        }
    },
});
const getWidgetStore = (widgetId) => {
    const widgetStore = window[`_widgetStore_${widgetId}`];
    if (widgetStore) {
        return widgetStore;
    }
    return (0, redux_1.createStore)(exports.rootReducers);
};
exports.getWidgetStore = getWidgetStore;
const initWidgetStore = (state, widgetId = '') => {
    const widgetStore = (0, redux_1.createStore)(exports.rootReducers, state);
    /** debug */
    window[`_widgetStore_${widgetId}`] = widgetStore;
    return widgetStore;
};
exports.initWidgetStore = initWidgetStore;
